module.exports = [{
      plugin: require('/home/travis/build/glaskawiec/gilbertlaskawiec-dot-com/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/home/travis/build/glaskawiec/gilbertlaskawiec-dot-com/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-140938699-1"},
    },{
      plugin: require('/home/travis/build/glaskawiec/gilbertlaskawiec-dot-com/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
